<template>
  <div class="container">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="展会名">
        <el-input v-model="form.title" placeholder="请输入展会名称"></el-input>
      </el-form-item>
      <el-form-item label="展会类型">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.type"
            :label="item.type"
            :value="item.type"
          ></el-option>
        </el-select>

        <el-button
                        type="text"
                        icon="el-icon-circle-plus"
                        @click="dialogVisibleAddress = true"
                      >添加类型</el-button>
      </el-form-item>
      <el-form-item label="展会时间">
        <div class="block">
          <el-date-picker v-model="form.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </div>
      </el-form-item>

      <el-form-item label="展会描述">
        <el-input type="textarea" autosize placeholder="请输入展会描述" v-model="form.content"></el-input>
      </el-form-item>
      <el-form-item label="展会图片">
        <el-upload
          class="upload-demo"
          drag
          action="/v2/validate/Upload"
          :headers="myHeaders"
          :on-success="handleSuccess"
          :show-file-list=false
          multiple
        >
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <div v-else>
            <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
            
          </div>
        </div>
          
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即创建</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="提示" :visible.sync="dialogVisibleAddress" width="30%">
      <el-form :model="form">
        <el-form-item label="展会类型*" :label-width="formLabelWidth">
          <el-input v-model="type" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAddress = false">取 消</el-button>
        <el-button type="primary" @click="AddType()">确 定</el-button>
      </div>
    </el-dialog>
  </div>

  
</template>

<script>
import store from "@/store";
import Vue from "vue";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  name: "CreateExhibition",
  data() {
    return {
      form: {},
      options: [{ value: "" }],
      myHeaders: { "Access-Token": Vue.ls.get(ACCESS_TOKEN) },
      imageUrl:'',
      dialogVisibleAddress:false,
      formLabelWidth:"120px",
      type:""
    };
  },
  methods: {
    handleSuccess(response, file, fileList) {
        this.imageUrl = URL.createObjectURL(file.raw);
      if (response.code == 0) {
        console.log(response.data);
        this.form.img = response.data;
      } else {
        alert(response.err);
      }
    },
    onSubmit() {
      this.$http
        .post("/v2/validate/CreateExhibition", {
          exhibition: this.form
        })
        .then(res => {
          alert("添加成功");
        })
        .catch(error => {});
    },
    AddType(){
      this.$http
        .post("/v2/validate/CreateExhibitionType", {
          type: this.type
        })
        .then(res => {
          this.options.push({type:this.type})
          alert("添加成功");
          this.dialogVisibleAddress = false
        })
        .catch(error => {});
    }
  },
  created() {
    this.$http
        .get("/v2/validate/GetExhibitionType", {
        })
        .then(res => {
          this.options = res.data
        })
        .catch(error => {});
  },
  mounted() {}
};
</script>

<style scoped>
</style>